import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  EditionsDataProps,
  getActiveEdition,
} from '../../components/navigation/header/primaryHeader/Editions';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { AMPSideBarLink } from './AMPSideBarLink';
import { BaseUnit } from '../../../theming/baseUnitDefinition';

interface AMPMenuEditionsThemeProps {
  dividerColor: string
  baseUnit: BaseUnit
}

type AMPMenuEditionsProps = AMPMenuEditionsThemeProps & EditionsDataProps;

const createStyle = (dividerColor: string, baseUnit: BaseUnit) => StyleSheet.create({
  divider: {
    backgroundColor: dividerColor,
    height: '1px',
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      margin: `0 ${baseUnit}px`,
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      margin: `0 ${baseUnit}px`,
    },
  },
});

export const AMPMenuEditions: React.FunctionComponent<AMPMenuEditionsProps> = props => {
  const { editions, dividerColor, baseUnit, editionEndpoint } = props;
  const activeEdition = getActiveEdition(editions, editionEndpoint);
  const { href, text } = activeEdition;
  const notActivatedEditions = editions.filter(edition => edition.text !== text);
  const style = createStyle(dividerColor, baseUnit);
  return (
    <React.Fragment>
      <div className={css(style.divider)} />
      {/*
  // @ts-ignore TS2339: Property 'amp-accordion' does not exist on type 'JSX.IntrinsicElements'. */}
      <amp-accordion id="editions-accordion" disable-session-states={undefined}>
        <AMPSideBarLink href={href} text={text} childrenLinks={notActivatedEditions} />
        {/*
  // @ts-ignore TS2339: Property 'amp-accordion' does not exist on type 'JSX.IntrinsicElements'. */}
      </amp-accordion>
    </React.Fragment>

  );
};
